/* =====================================================================
   RYNOR – policy pages: tidy the top of the policy text.
   Used by the old policy pages (sections/main-page.liquid) and Shopify's own policy pages
   (snippets/rynor-policy-page.liquid). Removes divider lines at the very top and a first heading
   that just repeats the page title (e.g. "SHIPPING POLICY" under the "Shipping Policy" title).
   ===================================================================== */
(function () {
  'use strict';

  if (window.__RYNOR_POLICY_PAGE_INIT__) return;
  window.__RYNOR_POLICY_PAGE_INIT__ = true;

  var DIVIDERS = 'hr, .hr, .divider, .section-divider, .line-divider, .border-top, .border-bottom, .or-divider';

  function normalizePolicyText(value) {
    return (value || '')
      .toLowerCase()
      .replace(/&amp;|&/g, 'and')
      .replace(/[^a-z0-9\s]/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function isSeparatorLike(el) {
    if (!el || el.nodeType !== 1) return false;
    if (/^(STYLE|SCRIPT|LINK|META)$/.test(el.tagName)) return false;
    if (el.matches(DIVIDERS)) return true;

    var text = (el.textContent || '').replace(/ /g, ' ').trim();
    var child = el.children.length === 1 ? el.children[0] : null;

    if (child && child.matches && child.matches(DIVIDERS)) return true;
    if (text && /^[_\-–—\s|•·]+$/.test(text)) return true;

    var style = window.getComputedStyle(el);
    if (style.display === 'contents') return false;
    var hasNoRealText = !text || /^[_\-–—\s|•·]+$/.test(text);
    var isThin = el.offsetHeight <= 12;
    var hasDividerBorder = parseFloat(style.borderTopWidth || 0) > 0 || parseFloat(style.borderBottomWidth || 0) > 0;

    return hasNoRealText && (isThin || hasDividerBorder);
  }

  function findTitle(inner) {
    var own = inner.querySelector('.policy-page__title');
    if (own && own.offsetParent !== null) return own;
    return inner.querySelector('.shopify-policy__container > .shopify-policy__title h1') || own;
  }

  function findContent(inner) {
    return inner.querySelector('.policy-page__content') ||
      inner.querySelector('.shopify-policy__body > .rte') ||
      inner.querySelector('.shopify-policy__body');
  }

  function cleanPolicyPage(scope) {
    var root = scope && scope.querySelectorAll ? scope : document;
    root.querySelectorAll('.policy-page__inner').forEach(function (inner) {
      if (inner.parentElement && inner.parentElement.closest('.policy-page__inner')) return;

      var titleEl = findTitle(inner);
      var contentEl = findContent(inner);
      if (!titleEl || !contentEl) return;

      var pageTitle = normalizePolicyText(titleEl.textContent);
      var guard = 0;

      while (contentEl.firstElementChild && isSeparatorLike(contentEl.firstElementChild) && guard < 6) {
        contentEl.firstElementChild.remove();
        guard += 1;
      }

      var firstContentChild = contentEl.firstElementChild;
      if (firstContentChild) {
        if (/^H[1-6]$/.test(firstContentChild.tagName) && normalizePolicyText(firstContentChild.textContent) === pageTitle) {
          firstContentChild.remove();
        } else {
          var nestedHeading = firstContentChild.querySelector && firstContentChild.querySelector('h1, h2, h3, h4, h5, h6');
          var wrapperText = normalizePolicyText(firstContentChild.textContent);
          if (nestedHeading && normalizePolicyText(nestedHeading.textContent) === pageTitle && (wrapperText === pageTitle || wrapperText === normalizePolicyText(nestedHeading.textContent))) {
            firstContentChild.remove();
          }
        }
      }

      guard = 0;
      while (contentEl.firstElementChild && isSeparatorLike(contentEl.firstElementChild) && guard < 6) {
        contentEl.firstElementChild.remove();
        guard += 1;
      }
    });
  }

  function runPolicyCleanup(event) {
    cleanPolicyPage(event && event.target && event.target.querySelectorAll ? event.target : document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runPolicyCleanup);
  } else {
    runPolicyCleanup();
  }

  document.addEventListener('shopify:section:load', runPolicyCleanup);
  document.addEventListener('shopify:section:select', runPolicyCleanup);
  document.addEventListener('shopify:section:reorder', runPolicyCleanup);
})();
